import React from 'react';
import styles from './InsightsCards.module.scss';
import Image from 'next/image';
import Button, { PRIMARY_THEME } from 'components/control/button';
import { buildClassName } from 'utils/build-class-name';

export type InsightCard = {
  title: string;
  subtitle?: string;
  date: string;
  url: string;
  image: string;
};

export type InsightsCardsProps = {
  cards: InsightCard[];
};

const InsightsCards = ({ cards }: InsightsCardsProps) => {
  return (
    <section className={styles.component}>
      <div className={styles.headerRow}>
        <h2 className={styles.heading}>INSIGHTS</h2>
        <a
          href="/insights"
          className={styles.viewAllBtn}
        >
          <Button label={'View All Insights'} theme={PRIMARY_THEME}/>
        </a>
      </div>
      <div className={styles.cardsWrapper}>
        {cards.map((card, idx) => (
          <a
            key={idx}
            href={card.url}
            className={styles.card}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className={styles.imageWrapper}>
              <Image src={card.image} alt={card.title} fill sizes="(max-width: 600px) 100vw, 25vw" />
            </div>
            <div className={styles.cardContent}>
              <div className={styles.subtitle}>{card.subtitle}</div>
              <div className={styles.title}>{card.title}</div>
              <div className={styles.date}>{card.date}</div>
            </div>
          </a>
        ))}
      </div>
      <a
        href="https://life.exprealty.com/insights/"
        className={buildClassName(styles.viewAllBtn, styles.viewAllBtnMobile)}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button label={'View All Insights'} theme={PRIMARY_THEME}/>
      </a>
    </section>
  );
};

export default InsightsCards; 